const educationTimeline = [
  {
    title: "Windfors Workshops",
    highlighted: "Creative Communications Program",
    desc:
      " - Part of Windfor's informal, creativity-led education program built on self-development, peer learning, and shared co-creation. A 12-week track (24 sessions) for 18–30 year-olds entering the creative communications industry, covering strategy, creative thinking, campaigns, copywriting, art direction, AI content production, and masterclasses.",
    date: "Feb - Jun 2026",
    link: "https://www.windforsworkshops.com",
    linkLabel: "Visit Windfors Workshops",
  },
];

export default educationTimeline;
